enum Subjects {
    MATH = 'MATH',
    PHYSIC = 'PHYSIC'
}

export default Subjects;